export const CURRENCIES = ["USD", "EUR", "SEK", "CNY"];
export const INC_PRICELIST_ID = 215;
